import { useTranslation } from 'react-i18next';

interface NavbarProps {
  scrolled: boolean;
}

export default function Navbar({ scrolled }: NavbarProps) {
  const { t, i18n } = useTranslation();

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  const languages = [
    { code: 'en', label: 'EN' },
    { code: 'zh-CN', label: '简体' },
    { code: 'zh-TW', label: '繁體' }
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="px-[5%] h-20 flex items-center justify-between">
        <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('home')}>
          <img
            src="https://static.readdy.ai/image/183f8cfb99a61f063094dcdb2d67a749/bd429f0e24d0f140c80be890f13f1a7b.png"
            alt="Global Pillar Limited"
            className="h-10 w-10 object-contain"
          />
          <span className={`font-semibold text-base transition-colors ${scrolled ? 'text-gray-900' : 'text-white'}`}>
            Global Pillar Limited
          </span>
        </div>
        <div className="flex items-center gap-10">
          {[
            { key: 'home', label: t('nav.home') },
            { key: 'solutions', label: t('nav.solutions') },
            { key: 'process', label: t('nav.process') },
            { key: 'contact', label: t('nav.contact') }
          ].map((item) => (
            <button
              key={item.key}
              onClick={() => scrollToSection(item.key)}
              className={`text-sm font-medium tracking-wide transition-all hover:opacity-70 relative group whitespace-nowrap ${
                scrolled ? 'text-gray-900' : 'text-white'
              }`}
            >
              {item.label}
              <span className={`absolute bottom-0 left-0 w-0 h-0.5 transition-all duration-300 group-hover:w-full ${
                scrolled ? 'bg-gray-900' : 'bg-white'
              }`}></span>
            </button>
          ))}
          
          {/* Language Switcher */}
          <div className="flex items-center gap-2 ml-4 border-l pl-4" style={{ borderColor: scrolled ? 'rgba(0,0,0,0.1)' : 'rgba(255,255,255,0.3)' }}>
            {languages.map((lang) => (
              <button
                key={lang.code}
                onClick={() => changeLanguage(lang.code)}
                className={`text-xs font-medium px-2 py-1 rounded transition-all whitespace-nowrap ${
                  i18n.language === lang.code
                    ? scrolled
                      ? 'bg-gray-900 text-white'
                      : 'bg-white text-gray-900'
                    : scrolled
                    ? 'text-gray-600 hover:text-gray-900'
                    : 'text-white/80 hover:text-white'
                }`}
              >
                {lang.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
}
